export default "__VITE_ASSET__ac8a52eb__"